import React from "react";
import { useIntl } from "@leagueplatform/locales";
import { usePageViewAnalytics } from "@leagueplatform/analytics";
import { useDocumentTitle } from "@leagueplatform/web-common";
import { Masonry } from "@leagueplatform/masonry";
import { MASONRY } from "common/constants";
import { JourneyContentWrapper } from "components/journey-content-wrapper.component";
import { PageContentWrapper } from "components/page-content-wrapper.component";
import { PageHeader } from "components/page-header/page-header.component";

export const AddedByMePage = () => {
  usePageViewAnalytics({ screen_name: "Added by me" });
  const { formatMessage } = useIntl();

  const addedByMeTitle = formatMessage({ id: "STR_ADDED_BY_ME" });
  useDocumentTitle(addedByMeTitle);

  return (
    <PageContentWrapper>
      <PageHeader
        variant="sub-page"
        mobileBand="none"
        headingText={addedByMeTitle}
      />
      <JourneyContentWrapper>
        <Masonry rootNodeId={MASONRY.ROOT_NODE_ID_ADDED_BY_ME} />
      </JourneyContentWrapper>
    </PageContentWrapper>
  );
};
